import Popover from "@material-ui/core/Popover";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { ReactComponent as BlankLink } from "assets/icons/Group 240018.svg";
import { ReactComponent as Archive } from "assets/icons/archive.svg";
import { ReactComponent as Duplicate } from "assets/icons/duplicate2.svg";
import { ReactComponent as Star } from "assets/icons/star.svg";
import React from "react";
import DeleteSvgComponent from "../assets/icons/svg/DeleteSvg/Delete";
import EditSvgComponent from "../assets/icons/svg/Edit/index";
import EyeSvgComponent from "../assets/icons/svg/EyeSvg/Eye";
import ActionSvgComponent from "../assets/icons/svg/actionSvg";
import { ReactComponent as CreateCampaignIcon } from "assets/icons/CreateCampaignBlue.svg";
import { ReactComponent as ActiveIcon } from "assets/icons/ActiveIcon.svg";
import { ReactComponent as PausedIcon } from "assets/icons/PausedIcon.svg";

import "./style.scss";
import { fontConfig } from "theme/fontConfig";

export default function CommunicationPopOver({
  onViewClick,
  onEditClick,
  onDuplicateClick,
  onDeleteClick,
  onCreateCampaignClick,
  onPauseStart,
  pauseOrStart,
  action,
  isEditHide,
  style,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <ActionSvgComponent
        height={style ? style.height : 14}
        width={style ? style.width : 14}
        onClick={handleClick}
        color={style && style.color}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          right: "300px",
          width: "182px",
        }}
      >
        <div
          className={`action-pop-over`}
          style={{
            width: "182px",
            fontFamily: fontConfig.CommunicationPopOverActionPopOverFont.family,
            fontSize: "14px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {onViewClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onViewClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <EyeSvgComponent className="svg-size" /> View
            </div>
          ) : (
            ""
          )}
          {onEditClick && !isEditHide ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onEditClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <EditSvgComponent className="svg-size" />
              {"Edit"}
            </div>
          ) : (
            ""
          )}
          {onCreateCampaignClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onCreateCampaignClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <CreateCampaignIcon className="svg-size" />
              {"Create campaign"}
            </div>
          ) : (
            ""
          )}
          {onDuplicateClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onDuplicateClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <Duplicate className="svg-size" /> {"Duplicate"}
            </div>
          ) : (
            ""
          )}
          {onPauseStart && pauseOrStart !== "" ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onPauseStart();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              {pauseOrStart === "Active" ? (
                <ActiveIcon
                  className="svg-size-active-pause"
                  style={{
                    width: "20px !important",
                  }}
                />
              ) : (
                <PausedIcon
                  className="svg-size-active-pause"
                  style={{
                    width: "20px !important",
                  }}
                />
              )}
              {pauseOrStart}
            </div>
          ) : (
            ""
          )}
          {onDeleteClick ? (
            <div
              className="delete-pop-over"
              onClick={() => {
                onDeleteClick();
                handleClose();
              }}
            >
              <DeleteSvgComponent className="svg-size" />
              {"Delete"}
            </div>
          ) : (
            ""
          )}
        </div>
      </Popover>
    </div>
  );
}
